<template>
  <div class="app-wrapper">
    <div class="main-container">
      <langHeaderEn/>
      <router-view></router-view>
      <!-- <app-main/> -->
    </div>
  </div>
</template>

<script>
import { langHeaderEn, langEn, BinfoEn, PersonalEn } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import request from '@/utils/request'

export default {
  data(){
    return{
      us:{}
    }
  },
  name: 'LayoutS',
  components: {
    langHeaderEn,
    langEn,
    BinfoEn,
    PersonalEn
  },
  mixins: [ResizeMixin],
  computed: {
  },
  created(){
    this.getinfo();
    // this.open()
  },
  mounted(){
  },
  methods: {
      getCookie(Name) { //cookie
        var search = Name + "=";
        var returnValue = "";
        if (document.cookie.length > 0) {
          var offset = document.cookie.indexOf(search);
          if (offset !== -1) {
            offset += search.length;
            var end = document.cookie.indexOf(";", offset);
            if (end == -1){
              end = document.cookie.length;
            }
            returnValue = decodeURIComponent(document.cookie.substring(offset, end));
          }
        }
        return returnValue;
      },
      // open() {
      //   if (this.getCookie('set') == ''){ //cookie 中没有 set 则赋给他一个值（此时弹框显示）
      //       document.cookie = "set = yes";
      //       this.$confirm('您还未设置偏好哦！是否前往设置', '提示', {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning',
      //         customClass: 'messageBox-prompt-test',
      //       }).then(() => {
      //           this.$router.push({path:'/personal'})
      //       })
      //   }
      // },
    //获取info
    getinfo(){
      if(localStorage.getItem('language') == 'en'){
        this.lang = 'English'
        document.getElementById('titleId').innerHTML = 'VReaLab'
      }else if(localStorage.getItem('language') == 'zh'){
        this.lang = '简体中文'
        document.getElementById('titleId').innerHTML = '3D仿真实验室'
      }
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
      }).catch(err=>{
        this.$confirm('The current account is already logged in on another device, Or not in use time', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'messageBox-btnFEN',
          confirmButtonClass: 'messageBox-btnTEN',
          type: 'warning',
        }).then(() => {
          this.logout();
        }).catch(() => {
          this.logout();
        })
      })
    },
    logout() {
              this.$store.dispatch('LogOut').then(() => {
         window.location.href="https://ziboedu.com.cn/portal/cas/ajax/logout.do?service=https://ziboedu.com.cn/portal"
        })
        /*
      if(localStorage.getItem('language') == 'en'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index'});
          localStorage.setItem('language','en');
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }else if(localStorage.getItem('language') == 'zh'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index'});
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }
  */

    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    width: 100%;
  }
  .app-main{
    background: #f5f5f5;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/langLayout.vue